import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StorybookModule } from '@storybook/storybook.module';
import { DeviceIconPipe } from './pipes/pipes';
import { LinkUpComponent } from '@settings/link-up/link-up.component';
import { LinkUpMainComponent } from '@settings/link-up/components/link-up-main/link-up-main.component';
import { LinkUpWorkstationDevicesComponent } from '@settings/link-up/components/link-up-workstation-devices/link-up-workstation-devices.component';
import { LinkUpWorkstationsListComponent } from '@settings/link-up/components/link-up-workstations-list/link-up-workstations-list.component';
import { RenameWorkstationDialogComponet } from '@settings/link-up/components/link-up-workstations-list/rename-workstation-dialog/rename-workstation-dialog.componet';
import { DeactivateWorkstationDialogComponent } from '@settings/link-up/components/link-up-workstations-list/deactivate-workstation-dialog/deactivate-workstation-dialog.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromLinkUpReducer from '@settings/link-up/store/reducers/link-up.reducers';
import { LinkUpEffects } from '@settings/link-up/store/effects/link-up.effects';
@NgModule({
  imports: [
    CommonModule,
    StorybookModule,
    StoreModule.forFeature(fromLinkUpReducer.FEATURE_KEY, fromLinkUpReducer.reducer),
    EffectsModule.forFeature([LinkUpEffects]),
  ],
  declarations: [
    LinkUpComponent,
    LinkUpMainComponent,
    LinkUpWorkstationDevicesComponent,
    LinkUpWorkstationsListComponent,
    DeviceIconPipe,
    RenameWorkstationDialogComponet,
    DeactivateWorkstationDialogComponent,
  ],
})
export class LinkUpModule {}
